
  import { defineComponent } from "vue";

  export default defineComponent({
    name: 'GeneralAgreement',
    title() {
      return 'Lennart Hakker - General agreement';
    },
  });
